// src/pages/ResetPasswordPage/index.js

import React, { useState, useContext } from 'react';
import { useParams, useHistory } from 'react-router-dom'; // ← changed import
import './ResetPasswordPage.css';
import UserContext from '../../contexts/UserContext';

const EyeIcon = ({ visible }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
    <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    {!visible && <line x1="3" y1="3" x2="21" y2="21" />}
  </svg>
);



const ResetPasswordPage = () => {
  const { token } = useParams();
  const history = useHistory(); // ← replaced useNavigate
  const { resetPassword } = useContext(UserContext);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [status, setStatus] = useState(null);
 const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setStatus('Passwords do not match.');
      return;
    }

    try {
     const data = await resetPassword(token, newPassword);
      setStatus('Password reset successful. Redirecting…');
      // ↓ use history.push instead of navigate
      setTimeout(() => history.push('/'), 2000);
    } catch (err) {
      setStatus(err.error || 'Reset failed.');
    }
  };

  return (
    <div className="reset-password-container">
      <h2>Reset Password</h2>
      <form onSubmit={handleSubmit} className="reset-password-form">
        <label>New Password</label>
        <div className="password-field">
          <input
            type={showNewPassword ? 'text' : 'password'}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
          <button
            type="button"
            className="password-toggle"
            onClick={() => setShowNewPassword((v) => !v)}
            aria-label={showNewPassword ? 'Hide password' : 'Show password'}
          >
            <EyeIcon visible={showNewPassword} />
          </button>
        </div>

        <label>Confirm Password</label>
       <div className="password-field">
          <input
            type={showConfirmPassword ? 'text' : 'password'}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
          <button
            type="button"
            className="password-toggle"
            onClick={() => setShowConfirmPassword((v) => !v)}
            aria-label={showConfirmPassword ? 'Hide password' : 'Show password'}
          >
            <EyeIcon visible={showConfirmPassword} />
          </button>
        </div>

        <button className="submit-button-Password" type="submit">Change Password</button>
      </form>
      {status && <p className="status-message">{status}</p>}
    </div>
  );
};

export default ResetPasswordPage;
